import service from "./index";

export default {
  async getAll(page = 0, size = 20) {
    const { data: trainers } = await service.get(
      `trainers/all?page=${page}&size=${size}`
    );

    return trainers;
  },
  async getAllList() {
    const { data: trainers } = await service.get("trainers");
    return trainers;
  },
  async get(id) {
    const { data: trainer } = await service.get(`trainers/${id}`);

    return trainer;
  },
  async create(data) {
    try {
      const { status } = await service.post("trainers/create", data);

      if (status === 201) {
        return true;
      }

      return false;
    } catch (error) {
      return false;
    }
  },
  async update(data) {
    try {
      const { status } = await service.put("trainers/update", data);

      if (status === 200) {
        return true;
      }

      return false;
    } catch (error) {
      return false;
    }
  },
  async updatePassword(data) {
    try {
      const { status } = await service.post("users/update-user-password", data);

      if (status === 200) {
        return true;
      }

      return false;
    } catch (error) {
      return false;
    }
  },
  async remove(id) {
    try {
      const { status } = await service.delete(`trainers/delete/${id}`);

      if (status === 200) {
        return true;
      }

      return false;
    } catch (error) {
      return false;
    }
  },
};



// WEBPACK FOOTER //
// ./src/api/trainers.js